import React from 'react'
import {TicketList} from '../../components'

const Ticket = () => {
  return (
    <div>
      <TicketList/>
    </div>
  )
}

export default Ticket